// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"51b8b774","332":"905304fb","526":"9c77282b"}[chunkId] + ".chunk.js";
};